<div style="position: relative;" class="mb-3" [style.height]="height + 10 + 'px'">
    <mat-label *ngIf="!label_block && !hide_label" class="label req text-nowrap html-textarea-label"
        [title]="label ? (label | HTMLFormatter : 1) : ''" [ngClass]="{'req':required}"
        [innerHtml]="label| HTMLFormatter : 1">
    </mat-label>
    <i class="fa fa-refresh float-right" (click)="clearCanvas()" matTooltip="Clear"></i>
    <div #canvas_container [style.width]="width" [style.height]="height + 'px'" class="canvas-container">
        <canvas #canvas></canvas>
    </div>
    <span class="d-block text-center hint">
        {{placeholder}}
    </span>
</div>
